import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { gameModel } from 'entities/game';
import { SidebarSettingsItem } from '../sidebar-settings-item';
import cls from './sidebar-settings.module.scss';

export const SidebarSettings = () => {
	const { t } = useTranslation();

	const [maxWin, maxBet, minBet] = useUnit([
		gameModel.$maxWin,
		gameModel.$maxBet,
		gameModel.$minBet,
	]);

	return (
		<ul className={cls.sidebarSettings}>
			<SidebarSettingsItem
				label={t('sidebar.settings.max-win')}
				value={maxWin}
			/>
			<SidebarSettingsItem
				label={t('sidebar.settings.max-bet')}
				value={maxBet}
			/>
			<SidebarSettingsItem
				label={t('sidebar.settings.min-bet')}
				value={minBet}
			/>
		</ul>
	);
};
